export enum Reason {
    ClientDeactivation,
    OrderCancel
  }